import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { rejectIncidentData } from 'src/app/domain/rejectIncident.model';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { ReasonSendMessageComponent } from '../reason-send-message/reason-send-message.component';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'neoris-reject-incidents',
  templateUrl: './reject-incidents.component.html',
  styleUrls: ['./reject-incidents.component.css']
})
export class RejectIncidentsComponent implements OnInit {

  ud: any={}
  private currentLang: string = "en"
  arrayRejectionReason:any[] = []

  form: UntypedFormGroup = this.fb.group({
    reason: ['', [Validators.required]],
    otherDescription: ['', [Validators.maxLength(200)]]
  })

  constructor(
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<RejectIncidentsComponent>,
    private controltowerservice: ControltowerService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: rejectIncidentData
  ) {
    if (this.translate.currentLang != undefined) {
      this.currentLang = this.translate.currentLang
    }
  }

  ngOnInit(): void {
    this.ud = JSON.parse(localStorage.getItem('ud'))
    this.getGenericAtrributeValue(this.currentLang)
  }

  private async getGenericAtrributeValue(localCode:string): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAttributeValue(localCode).subscribe(
        {
          next: (attribute: any={}) => {

           const REJECTION_REASON_ATRIBUTE = attribute.attributeTypes.find(f => f.id == 45)
           if(REJECTION_REASON_ATRIBUTE !== undefined){
            this.arrayRejectionReason = REJECTION_REASON_ATRIBUTE.attributeValues
           }
          
           if (this.arrayRejectionReason.length > 0){
            this.form.get('reason').setValue(this.arrayRejectionReason[0])
           }
  
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  public sendReasonForRejection(){

    this.form.updateValueAndValidity();
    const isFormValid: boolean = this.form.valid;
    if (isFormValid) {

      const reason = this.form.get('reason').value
      const otherDescription = this.form.get('otherDescription').value
      const eventId = this.data.eventId

      const userName: string = this.ud[0].value

      return new Promise<boolean>((resolve, reject) => {
        this.controltowerservice.rejectIncident(eventId, reason.id, otherDescription, userName).subscribe(
          {
            next: (attribute: any={}) => {

              this.dialogRef.close(true)
              this.ShowSendMessage()
                           
              resolve(true);
            }, error: (error: HttpErrorResponse) => {
             
              const error_message = this.translate.instant('REJECTED_REASON_ERROR_MESSAGE')
              this.openSnackBar(error_message,'ERROR')

              resolve(false);
            }
          }
        )
      });
    }
  }

  openSnackBar(message: string, action: string) {
    if (action == 'OK') {
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['blue-snackbar']
      });
    }
    else {
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['blue-snackbar-false']
      });
    }
  }

  private ShowSendMessage(){
    this.dialog.open(ReasonSendMessageComponent,
      {
        restoreFocus: false,
        width: '600px',
        height: '599px'
      });
  }


}
